'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useState } from 'react';
import { createDesktopControlBarViewportLayout } from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarDesktopLayout';
import { createKidsModeControlBarViewportLayout } from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarKidsModeLayout';
import { createMobileControlBarViewportLayout } from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarMobileLayout';
import ControlBarViewportLayout, { type ControlBarViewportLayoutProps } from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarViewportLayout';
import type { ControlBarPresentation } from '@/constants/control-bar';
import { useUAContext } from '@/context/UAContext';
import { useWorldDetailsContext } from '@/context/WorldDetailsContext';
import type { RecommendRoom } from '@/services/cms';
type ControlBarPresentationLayoutProps = {
  children: ReactNode;
  presentation: ControlBarPresentation;
};
function createNoControlBarViewportLayout(): Omit<ControlBarViewportLayoutProps, 'children'> {
  return {
    barPlacement: 'before',
    className: 'flex h-full min-h-0 min-w-0 flex-1 flex-col',
    renderControlBar: () => null,
    showToaster: false
  };
}
function createControlBarViewportLayout(presentation: ControlBarPresentation, isFullscreenBarHidden: boolean, isMobileLandscape: boolean, moreRecommendationsPromise: Promise<RecommendRoom[]> | null, onHideAction: () => void) {
  switch (presentation.kind) {
    case 'desktop':
      return createDesktopControlBarViewportLayout({
        isHidden: isFullscreenBarHidden,
        moreRecommendationsPromise,
        onHideAction,
        surface: presentation.surface,
        variant: presentation.variant
      });
    case 'mobile':
      return createMobileControlBarViewportLayout({
        isMobileLandscape,
        moreRecommendationsPromise
      });
    case 'kids-mode':
      return createKidsModeControlBarViewportLayout(isMobileLandscape);
    case 'none':
      return createNoControlBarViewportLayout();
  }
}
export default function ControlBarPresentationLayout(t0) {
  const $ = _c(9);
  const {
    children,
    presentation
  } = t0;
  const {
    logoOverlayRoomsPromise
  } = useWorldDetailsContext();
  const {
    isMobileLandscape
  } = useUAContext();
  const [isFullscreenBarHidden, setIsFullscreenBarHidden] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsFullscreenBarHidden(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isFullscreenBarHidden || $[2] !== isMobileLandscape || $[3] !== logoOverlayRoomsPromise || $[4] !== presentation) {
    t2 = createControlBarViewportLayout(presentation, isFullscreenBarHidden, isMobileLandscape, logoOverlayRoomsPromise, t1);
    $[1] = isFullscreenBarHidden;
    $[2] = isMobileLandscape;
    $[3] = logoOverlayRoomsPromise;
    $[4] = presentation;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const viewportLayout = t2;
  let t3;
  if ($[6] !== children || $[7] !== viewportLayout) {
    t3 = <ControlBarViewportLayout {...viewportLayout}>{children}</ControlBarViewportLayout>;
    $[6] = children;
    $[7] = viewportLayout;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}